import ReactExport from 'react-data-export';
import { IDonorSurgeon, ISwapQualityIssueForReport } from '@nkr/models/index';
import { Button } from 'react-bootstrap';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelSheet;

interface IProps {
    data: {
        donorSurgeons: IDonorSurgeon[],
        issues: ISwapQualityIssueForReport[]
    }
}

const DownloadReport = (props: IProps) => {
    const dataSheet1 = [
        {
            columns: [
                { title: 'R#', width: { wpx: 50 } },
                { title: 'Donor Center', width: { wpx: 150 } },
                { title: 'Donor Surgeon', width: { wpx: 150 } },
                { title: 'Recipient Center Issues', width: { wpx: 150 } },
                { title: 'Nephrectomy Count', width: { wpx: 150 } },
                { title: 'Issue Rate' }
            ],
            data: props.data.donorSurgeons.map((surgeon, i) => {
                return [
                    { 
                        value: i + 1,
                        style: {
                            alignment: {
                                horizontal: 'center'
                            }
                        }
                    },
                    { value: surgeon.centerAlias },
                    { value: surgeon.fullName },
                    {
                        value: surgeon.issueCount,
                        style: {
                            alignment: {
                                horizontal: 'center'
                            }
                        }
                    },
                    {
                        value: surgeon.count,
                        style: {
                            alignment: {
                                horizontal: 'center'
                            }
                        }
                    },
                    {
                        value: surgeon.issueRate / 100,
                        style: {
                            alignment: {
                                horizontal: 'center'
                            },
                            numFmt: '0%'
                        }
                    }
                ];
            })
        }
    ];

    const dataSheet2 = [
        {
            columns: [
                { title: 'R#', width: { wpx: 50 } },
                { title: 'Donor Center', width: { wpx: 150 } },
                { title: 'Donor Surgeon', width: { wpx: 150 } },
                { title: 'Recipient Center', width: { wpx: 150 } },
                { title: 'Recipient Surgeon', width: { wpx: 150 } },
                { title: 'Recipient Issue Type(s)', width: { wpx: 170 } },
                { title: 'Recipient Center Comments', width: { wpx: 400 } },
                { title: 'Nephrectomy Date', width: { wpx: 130 } }
            ],
            data: props.data.issues.map((issue, i) => {
                return [
                    { 
                        value: i + 1,
                        style: {
                            alignment: {
                                horizontal: 'center'
                            }
                        }
                    },
                    {
                        value: issue.donorCenterName,
                        style: {
                            alignment: {
                                vertical: 'top'
                            }
                        }
                    },
                    {
                        value: issue.donorSurgeonName,
                        style: {
                            alignment: {
                                vertical: 'top'
                            }
                        }
                    },
                    {
                        value: issue.recipientCenterName,
                        style: {
                            alignment: {
                                vertical: 'top'
                            }
                        }
                    },
                    {
                        value: issue.recipientSurgeonName,
                        style: {
                            alignment: {
                                vertical: 'top'
                            }
                        }
                    },
                    {
                        value: issue.recipientSwapQualityIssueTypes.join(', '),
                        style: {
                            alignment: {
                                vertical: 'top',
                                wrapText: true
                            }
                        }
                    },
                    {
                        value: issue.recipientIssueDescription,
                        style: {
                            alignment: {
                                vertical: 'top',
                                wrapText: true
                            }
                        }
                    },
                    {
                        value: issue.nephrectomyDate,
                        style: {
                            alignment: {
                                vertical: 'top',
                                horizontal: 'right'
                            }
                        }
                    }
                ]
            })
        }
    ]

    return (
        <ExcelFile filename='SwapQualityIssuesReport.xlsx' element={<Button>Download Excel</Button>}>
            <ExcelSheet dataSet={dataSheet1} name='Issue Rate by Donor Surgeon' />
            <ExcelSheet dataSet={dataSheet2} name='Issues by Donor Surgeon' />
        </ExcelFile >
    );
}

export default DownloadReport;